import actionTypes from '../actionTypes';

/*  

  define agentList for one to one agent mapping
  agentList :: agentList["devid"] = {"state":"","timestamp":"","extraInfo"}

  filter :: define for filter
  filter :: {"startDate":"","endDate":""}

  stateList => Define for agent state list array
  
  monitorStats => Define for all call count


*/ 
const initialState = {
  agentList: {},
  filter: {},
  stateList: {},
  queue : {}
};

export default (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.LIVE_AGENT_LIST:
      newState.agentList = action.payload.data;
      return newState;
    case actionTypes.LIVE_FILTER:
      newState.filter = action.payload.data;
      return newState;
    case actionTypes.LIVE_STATE_LIST:
      newState.stateList = action.payload.data;
      return newState;
    case actionTypes.LIVE_QUEUE:
      newState.queue = action.payload.data;
      return newState;
    case actionTypes.LIVE_SET_AGENT_LIST:
      if( action.payload.key && action.payload.value )
        newState.agentList[ action.payload.key ] = action.payload.value;
      return newState;
    case actionTypes.LIVE_SET_FILTER:
      if( action.payload.key && action.payload.value )
        newState.filter[ action.payload.key ] = action.payload.value;
      return newState;
    case actionTypes.LIVE_SET_STATE_LIST:
      if( action.payload.key && action.payload.value )
        newState.stateList[ action.payload.key ] = action.payload.value;
      return newState;
    case actionTypes.LIVE_SET_QUEUE:
      if( action.payload.key && action.payload.value )
        newState.queue[ action.payload.key ] = action.payload.value;
      return newState;
    case actionTypes.LIVE_DYNAMIC_UPDATE:
      if( action.payload.key && action.payload.value )
        newState[ action.payload.key ] = action.payload.value;
      else if( typeof action.payload == "object" && Object.keys(action.payload).length > 0 ){
        for (const key in action.payload) {
          if( key && action.payload[key] ){
            newState[ key ] = action.payload[key];
          }
        }
      }
      return newState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/livemonitor.reducer.js